export { MediaRecorderComponent } from './media-recorder.component';
export { MediaRecorderModule } from './media-recorder.module';
